<template>
  <div class="wrapper">
    <div class="sizes">
      <div
        :class="['item', { on: sizeId == size.id }]"
        v-for="(size, index) in sizes"
        :key="index"
        @click="selectSize(size)"
      >
        <span>{{ size.sizeName }}</span>
        <span>{{ size.width }}*{{ size.height }}</span>
        <i class="enter"></i>
        <i class="iconfont icon-gouxuan"></i>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { getProdSizes } from "./js/cover-feature";
export default {
  name: "SizeChoose",
  data() {
    return {
      sizes: [],
    };
  },
  computed: {
    ...mapState("cover", ["coverData"]),
    sizeId() {
      return this.coverData.sizeId;
    },
  },
  async mounted() {
    // 获取封面的业务线（sizes）
    this.sizes = await getProdSizes();
  },
  methods: {
    ...mapMutations("cover", ["updateCoverData", "updateCoverDataList"]),
    navigateBack() {
      this.$router.back();
    },
    // 选中一个业务线
    async selectSize(size) {
      const {
        id,
        elementHeight,
        elementWidth,
        height,
        width,
        offsetX,
        offsetY,
        remainPart,
        sizeName,
        textAlignType,
        textPositionX,
        textPositionY,
        type,
      } = size;
      // 设置选中的size
      this.updateCoverData({
        sizeId: id + "",
        sizeName,
        type,
        size: {
          width,
          height,
        },
        elementInfo: {
          elementWidth,
          elementHeight,
          offsetX,
          offsetY,
          remainPart,
        },
        textInfo: {
          textPositionX,
          textPositionY,
          textAlignType,
        },
        fontStyles: [],
      });
      this.updateCoverDataList({
        isClearCoverDataList: true,
        num: 1,
      });
      this.$router.push({
        path: "/cover/build",
        query: this.$route.query,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .sizes {
    display: flex;
    justify-content: space-between;
    margin: auto;
    .item {
      position: relative;
      margin: 8px;
      padding-left: 28px;
      display: flex;
      box-sizing: border-box;
      width: 144px;
      height: 126px;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      border-radius: 12px;
      border: 2px solid #fff;
      line-height: 28px;
      background: #fff;
      transition: all 0.2s;
      color: #464c5e;
      cursor: pointer;
      user-select: none;
      &:hover {
        transform: translateY(-4px);
        box-shadow: 0px 9px 13px 0px rgba(0, 0, 0, 0.1);
        .enter {
          width: 25px;
        }
      }
      .enter {
        display: inline-block;
        width: 0px;
        height: 4px;
        margin-top: 8px;
        border-radius: 4px;
        background: #3f69f9;
        overflow: hidden;
        transition: all 0.2s;
      }
      .iconfont {
        position: absolute;
        right: 3px;
        bottom: -5px;
        opacity: 0;
        color: #fff;
        z-index: 2;
      }
      &:after {
        position: absolute;
        right: -1px;
        bottom: -1px;
        width: 25px;
        height: 20px;
        border-top-left-radius: 22px;
        background-color: #3f69f9;
        opacity: 0;
        z-index: 1;
        content: "";
      }
      &.on {
        border-color: #3f69f9;
        overflow: hidden;
        &:after {
          opacity: 1;
        }
        .iconfont {
          opacity: 1;
          font-size: 12px;
          transform: scale(0.7);
        }
      }
    }
  }
}
</style>
